import React from 'react'
import Navbar from '../components/Navbar'
import HeroImage from '../components/HeroImage'
import Footer from '../components/Footer'
import Work from './../components/Work';
import Technologies from '../components/Technologies';
import Featured from '../components/Featured';

const Home = () => {
  return (
    <div>
      <Navbar />
      <HeroImage />
      <Technologies/>
      <Work />
      <Featured/>
      <Footer />
    </div>
  )
}

export default Home
